import React from 'react';
import { styled } from 'linaria/react';
import CategoryLink from '@jetshop/ui/CategoryLink';
import { theme } from '../Theming/Theming';
import SubcategoriesGridQuery from './SubcategoriesGridQuery.gql';
import { useQuery } from 'react-apollo';
import Image from '@jetshop/ui/Image';

const SubCategoriesWrapper = styled.div`
  padding: 0.7rem 0;
  ul.subcategories-grid-list {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -1rem;
    > li {
      width: 50%;
      padding: 1rem;
      ${theme.above.md} {
        width: 33.333%;
      }
      ${theme.above.lg} {
        width: 25%;
      }
    }
  }
`;

const SubCategory = styled.li`
  > a {
    text-align: center;
    box-shadow: 1px 1px 10px #0000004d;
    display: block;
    padding: 10px;
  }
`;

const NameTag = styled('h3')`
  padding: 1rem;
`;

export const SubCategoriesGrid = ({ category }) => {
  //FETCHING SIBLING CATEGORIES
  const result = useQuery(SubcategoriesGridQuery, {
    variables: { id: category.id }
  });

  //SHOW SUBCATEGORIES OR SIBLINGCATEGORIES
  const subcategories = result.data?.category?.subcategories;

  if (subcategories && subcategories.length > 0)
    return (
      <SubCategoriesWrapper className="subcategories-grid-wrapper">
        <ul className="subcategories-grid-list">
          {subcategories.map(item => {
            const image = item.images.length > 0 && item.images[4].url;
            return (
              <SubCategory key={item.id}>
                <CategoryLink category={item}>
                  {image && (
                    <Image
                      aspect={'1:1'}
                      crop={false}
                      src={item.images[4].url}
                      sizes={[1 / 2, 1 / 3, 1 / 4, 1 / 4]}
                      quality={80}
                      alt={item.name}
                      title={item.name}
                    />
                  )}
                  <NameTag>{item.name}</NameTag>
                </CategoryLink>
              </SubCategory>
            );
          })}
        </ul>
      </SubCategoriesWrapper>
    );
  else return null;
};
